import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Recaptcha from 'react-gcaptcha';
import styles from './ResendCaptchaModal.css';

class ResendCaptchaModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validCaptcha: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show && !this.props.show) {
      this.setState({
        validCaptcha: false,
      });
    }
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <Modal.Header>
          <Modal.Title className={styles.title}>Resend Invitation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Human Verification</p>
          <Recaptcha
            sitekey="6LesGA4UAAAAAMQ4EgXcvuxeJOXdIo217ldryOms"
            verifyCallback={this._verifyCallback}
            expiredCallback={this._expiredCallback}
          />
        </Modal.Body>
        <Modal.Footer>
          <span className="pull-left">
            <button className="btn btn-default" onClick={this._onCancel}>
              Cancel
            </button>
          </span>
          <span className="pull-right">
            <button
              className="btn btn-primary"
              onClick={this._onClickResend}
              disabled={!this.state.validCaptcha}
            >
              Resend
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }

  _onCancel = () => {
    this.props.onCancel();
  };

  _onClickResend = () => {
    if (this.state.validCaptcha) {
      this.props.onClickWithValidCaptcha();
    }
  };

  _verifyCallback = () => {
    this.setState({
      validCaptcha: true,
    });
  };

  _expiredCallback = () => {
    this.setState({
      validCaptcha: false,
    });
  };
}

ResendCaptchaModal.propTypes = {
  show: PropTypes.bool,
  onClickWithValidCaptcha: PropTypes.func,
  onCancel: PropTypes.func,
};

export default ResendCaptchaModal;
